// Divergence Points — the canonical scoring formula for every surface
// that accumulates DP (Leaderboard, mock ticker, pledge history, any
// future settlement payout). Centralised here so a single edit changes
// the rule everywhere instead of drifting across call sites.
//
// Formula (Architect's Sound Foundation brief, v1.9):
//
//     DP  =  Σ  units × (1 − price)
//
// Interpretation: a pledge placed at price `p` earns `(1 − p)` DP per
// unit if it resolves in the citizen's favour. Low-price (longshot)
// pledges earn more DP per unit, which is exactly the divergence
// incentive the protocol is meant to amplify. Prices are clamped to
// [0, 1] — stray values from a mid-flight race condition shouldn't
// negative-score or super-score a row.

export function calcDivergencePoints(units: number, price: number): number {
  const safePrice = Math.max(0, Math.min(1, price));
  return units * (1 - safePrice);
}
